import * as React from 'react';

function SvgPaymentVisa(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={78} height={50} viewBox="0 0 78 50" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#A4A4AD"
          d="M5.77 0h66.46c2 0 2.73.2 3.47.6.73.4 1.3.97 1.7 1.7.4.74.6 1.46.6 3.47v38.46c0 2-.2 2.73-.6 3.47-.4.73-.97 1.3-1.7 1.7-.74.4-1.46.6-3.47.6H5.77c-2 0-2.73-.2-3.47-.6-.73-.4-1.3-.97-1.7-1.7-.4-.74-.6-1.46-.6-3.47V5.77c0-2 .2-2.73.6-3.47C1 1.57 1.57 1 2.3.6 3.04.2 3.76 0 5.77 0z"
        />
        <path
          fill="#FFF"
          d="M5.99 1.5H72c1.56 0 2.13.16 2.7.47.57.3 1.02.75 1.32 1.32.3.57.47 1.14.47 2.7V44c0 1.56-.16 2.13-.47 2.7-.3.57-.75 1.02-1.32 1.32-.57.3-1.14.47-2.7.47H6c-1.56 0-2.13-.16-2.7-.47a3.18 3.18 0 01-1.32-1.32c-.3-.57-.47-1.14-.47-2.7V6c0-1.56.16-2.13.47-2.7.3-.57.75-1.02 1.32-1.32.57-.3 1.14-.47 2.7-.47z"
        />
        <path
          fill="#00579F"
          d="M49.2 18.84a9.37 9.37 0 00-3.23-.55c-3.55 0-6.05 1.77-6.07 4.3-.02 1.88 1.78 2.92 3.15 3.54 1.4.64 1.87 1.05 1.86 1.62-.01.87-1.12 1.27-2.15 1.27a7.6 7.6 0 01-3.38-.68l-.47-.2-.5 2.9c.84.37 2.4.69 4 .7 3.78 0 6.23-1.74 6.26-4.45.01-1.48-.95-2.61-3.02-3.54-1.25-.6-2.02-1-2.01-1.61 0-.55.65-1.13 2.05-1.13a6.7 6.7 0 012.7.5l.31.15.5-2.82m4.77 8.09l1.43-3.64.48-1.25.24 1.13.84 3.76h-2.99zm4.43-8.4h-2.77c-.86 0-1.5.23-1.88 1.08L48.4 31.55h3.77l.76-1.95h4.6l.44 1.95h3.33l-2.9-13.02zm-28.84 0l-3.52 8.88-.38-1.8c-.65-2.08-2.7-4.34-4.97-5.47l3.21 11.4h3.8l5.66-13.01h-3.8"
        />
        <path
          fill="#F9A51A"
          d="M22.78 18.52h-5.8l-.04.27c4.5 1.08 7.49 3.69 8.72 6.82l-1.26-5.99c-.21-.82-.84-1.07-1.62-1.1"
        />
        <path
          fill="#00579F"
          d="M34.82 18.52l-2.25 13.03h3.6l2.24-13.03zM5.77 0h66.46c2 0 2.73.2 3.47.6.73.4 1.3.97 1.7 1.7.4.74.6 1.46.6 3.47V13H0V5.77c0-2 .2-2.73.6-3.47C1 1.57 1.57 1 2.3.6 3.04.2 3.76 0 5.77 0z"
        />
        <path
          fill="#F9A51A"
          d="M72.23 50H5.77c-2 0-2.73-.2-3.47-.6-.73-.4-1.3-.97-1.7-1.7-.4-.74-.6-1.46-.6-3.47V37h78v7.23c0 2-.2 2.73-.6 3.47-.4.73-.97 1.3-1.7 1.7-.74.4-1.46.6-3.47.6z"
        />
        <path
          fill="#A4A4AD"
          fillOpacity={0.65}
          fillRule="nonzero"
          d="M72.23 0c2 0 2.73.2 3.47.6.73.4 1.3.97 1.7 1.7.4.74.6 1.46.6 3.47v39c-.04 1.6-.25 2.26-.6 2.93-.4.73-.97 1.3-1.7 1.7-.74.4-1.46.6-3.47.6h-67c-1.6-.04-2.26-.25-2.93-.6-.73-.4-1.3-.97-1.7-1.7-.37-.7-.58-1.4-.6-3.2V5.78c0-2 .2-2.73.6-3.47C1 1.57 1.57 1 2.3.6 3 .23 3.7.02 5.5 0h66.73zM73 1.5H5A3.5 3.5 0 001.5 5v40A3.5 3.5 0 005 48.5h68a3.5 3.5 0 003.5-3.5V5A3.5 3.5 0 0073 1.5z"
        />
      </g>
    </svg>
  );
}

export default SvgPaymentVisa;
